/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import { Helmet } from "react-helmet";

export const DocumentTitle: React.FC<{ title: string }> = ({ title }) => (
  <Helmet>
    <title>{title}</title>
    <meta property="og:title" content={title} />
    <meta property="twitter:title" content={title} />
  </Helmet>
);

export const DocumentDescription: React.FC<{ description: string }> = ({
  description,
}) => (
  <Helmet>
    <meta property="twitter:description" content={description} />
    <meta name="description" content={description} />
    <meta property="og:description" content={description} />
  </Helmet>
);

export const DocumentImagePreview: React.FC<{ url: string }> = ({ url }) => (
  <Helmet>
    <meta property="og:image" content={url} />
    <meta property="twitter:image" content={url} />
  </Helmet>
);
